import { useCallback, useEffect, useMemo, useState } from 'react';
import { attendanceService } from '../../services/attendance';

const sum = (rows, key) => rows.reduce((acc, row) => acc + (Number(row?.[key]) || 0), 0);

export const usePayrollSummary = (filters) => {
  const [timeEntries, setTimeEntries] = useState([]);
  const [summaryRows, setSummaryRows] = useState([]);
  const [venueTotals, setVenueTotals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');

    try {
      const [entries, payroll] = await Promise.all([
        attendanceService.getWeeklyTimeEntries(filters),
        attendanceService.getPayrollSummary(filters),
      ]);

      setTimeEntries(entries);
      setSummaryRows(payroll.summary);
      setVenueTotals(payroll.totals);
    } catch (err) {
      setError(attendanceService.mapErrorMessage(err, 'Failed to load weekly payroll'));
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const calculatedTotals = useMemo(() => {
    if (venueTotals.length > 0) return venueTotals[0];

    const distinctStaff = new Set(timeEntries.map((row) => row.user_id).filter(Boolean));
    return {
      total_paid_hours: sum(timeEntries, 'paid_hours'),
      total_shifts: timeEntries.length,
      staff_count: distinctStaff.size,
    };
  }, [timeEntries, venueTotals]);

  return {
    timeEntries,
    summaryRows,
    venueTotals,
    calculatedTotals,
    loading,
    error,
    refresh,
  };
};
